module.exports = __webpack_public_path__ + "img/Weapon_109.c245a9f5.png";